'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import { CommonButton } from '@components/common-button/CommonButton';
import school from '@images/renders/infrastructure_images/Infra_Desktop_Webp/school.webp';
import school_mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/school-mob.webp';
import ROUTES from '@lib/constants/routes';
import { animated, useInView } from '@react-spring/web';
import cl from 'classnames';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useRouter } from 'next/navigation';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import style from './SecondScreenInfra.module.scss';
function SecondScreenInfra(t0) {
  const $ = _c(35);
  const {
    infra,
    isMobile
  } = t0;
  const lineRef = useRef(null);
  const [toggle, setToggle] = useState(false);
  const router = useRouter();
  const listItems = ["\u0411\u0438\u043E\u0444\u0438\u043B\u044C\u043D\u044B\u0439 \u0434\u0438\u0437\u0430\u0439\u043D \u0441\u0440\u0435\u0434\u044B", "\u0417\u043E\u043D\u044B \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0432\u043E\u0441\u043F\u0438\u0442\u0430\u043D\u0438\u044F", "\u0423\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430"];
  const [titleRef, titleInView] = useInView();
  const [bottomRef, bottomInView] = useInView();
  const getView = _temp;
  let t1;
  let t2;
  if ($[0] !== isMobile) {
    t1 = () => {
      if (lineRef?.current) {
        let st = null;
        const element = lineRef.current;
        setTimeout(() => {
          st = ScrollTrigger.create({
            trigger: element,
            start: "top center",
            scroller: !isMobile ? "#smooth-wrapper" : "body",
            scrub: true,
            pin: false,
            onToggle: () => {
              setTimeout(() => {
                setToggle(_temp2);
              }, 400);
            }
          });
          return () => {
            st.kill();
          };
        }, 1000);
      }
    };
    t2 = [lineRef, isMobile];
    $[0] = isMobile;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  const t3 = true;
  const t4 = !infra && style.aboutWrapper;
  let t5;
  if ($[3] !== t4) {
    t5 = cl(style.wrapper, t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = "about";
  let t7;
  if ($[5] !== infra || $[6] !== isMobile || $[7] !== toggle) {
    t7 = infra && <div className={style.svgLineWrapper} ref={lineRef}><AnimateLines id={!isMobile ? "infrastructure-2" : "infrastructure-2-mob"} className={style.svgClass} toggle={toggle} /></div>;
    $[5] = infra;
    $[6] = isMobile;
    $[7] = toggle;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== titleInView) {
    t8 = getView(titleInView);
    $[9] = titleInView;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t10;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={style.title}><p>Школа больших</p><p>перемен</p></div>;
    t10 = <p>Своя школа на 350 мест и детский сад на 175 мест вдохновляют учиться и познавать мир через его красоту.</p>;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  let t11;
  if ($[13] !== t8 || $[14] !== titleRef) {
    t11 = <animated.div className={style.topTextContent} ref={titleRef} style={t8}>{t9}{t10}</animated.div>;
    $[13] = t8;
    $[14] = titleRef;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ParallaxMedia src={school} src375={school_mob} className={style.image} />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = style;
  let t14;
  if ($[17] !== bottomInView) {
    t14 = getView(bottomInView);
    $[17] = bottomInView;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = listItems.map(_temp3);
  let t16;
  if ($[19] !== t15) {
    t16 = <ul>{t15}</ul>;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== router) {
    t17 = <CommonButton text={"\u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"} className={style.button} handleFunction={() => router.push(ROUTES.school)} />;
    $[21] = router;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== bottomRef || $[24] !== t13.bottomContent || $[25] !== t14 || $[26] !== t16 || $[27] !== t17) {
    t18 = <div className={t13.bottomContent} ref={bottomRef} style={t14}>{t16}{t17}</div>;
    $[23] = bottomRef;
    $[24] = t13.bottomContent;
    $[25] = t14;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t18 || $[32] !== t5 || $[33] !== t7) {
    t19 = <div data-scroll={t3} className={t5} id={t6}>{t7}{t11}{t12}{t18}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t18;
    $[32] = t5;
    $[33] = t7;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
}
function _temp3(item, index) {
  const uniqueKey = `${item.charAt(0)}-${index}`;
  return <li key={uniqueKey}>{item}</li>;
}
function _temp2() {
  return true;
}
function _temp(view) {
  return {
    opacity: view ? 1 : 0,
    transition: "1s ease",
    position: "relative",
    top: view ? 0 : 80
  };
}
export default SecondScreenInfra;